import React, {useEffect} from "react";
import st from "@/styles/LoginPage.module.scss"
import LoginForm from "./elemsV2/LoginForm.tsx";
import DashboardHeader from "@/ui/DashboardHeader.tsx";
import { useNavigate } from 'react-router-dom';
import Bottom from "@/ui/Bottom.tsx";
import DashboardClass from "@/utils/dashboard_class.ts";

const LoginPageView:React.FC = () => {

    const navigate = useNavigate();
    const searchParams = new URLSearchParams(location.search);
    const step = searchParams.get('step');
    
    useEffect(() => {
        
        if(!step) {
            navigate(DashboardClass.login_routes.LoginStep1)
        }

    }, []);
    
    
    return (
        <main className={st.main}>
            <DashboardHeader />
            
            <LoginForm step={Number(step)} />
            
            <Bottom />
        </main>
    )
}

export default LoginPageView